if (!customElements.get('collection-wallpaper-products')) {
  customElements.define(
    'collection-wallpaper-products',
    class CollectionWallpaperProducts extends HTMLElement {
      constructor() {
        super();
        this.swiper = null;
        this.swiperLoadAttempts = 0;
        this.listingLoadAttempts = 0;
        this.listingInitialized = false;
        this.initTimeout = null;
        this.listingTimeout = null;
        this.desktopQuery = window.matchMedia('(min-width: 769px)');
        this.handleBreakpointChange = this.handleBreakpointChange.bind(this);
      }

      connectedCallback() {
        this.carousel = this.querySelector('[data-wallpaper-types-carousel]');
        this.desktopQuery.addEventListener('change', this.handleBreakpointChange);
        this.handleBreakpointChange();
        this.initListingWhenReady();
      }

      disconnectedCallback() {
        this.desktopQuery.removeEventListener('change', this.handleBreakpointChange);
        window.clearTimeout(this.initTimeout);
        window.clearTimeout(this.listingTimeout);
        this.destroySwiper();
      }

      handleBreakpointChange() {
        if (this.desktopQuery.matches) {
          window.clearTimeout(this.initTimeout);
          this.destroySwiper();
          return;
        }

        this.swiperLoadAttempts = 0;
        this.initSwiper();
      }

      destroySwiper() {
        if (!this.swiper) return;
        this.swiper.destroy(true, true);
        this.swiper = null;
      }

      initSwiper() {
        if (!this.carousel || this.swiper || this.desktopQuery.matches) return;

        const slides = this.carousel.querySelectorAll('.swiper-slide');
        if (slides.length < 2) return;

        if (typeof window.Swiper !== 'function') {
          if (this.swiperLoadAttempts < 40) {
            this.swiperLoadAttempts += 1;
            this.initTimeout = window.setTimeout(() => this.initSwiper(), 50);
          }
          return;
        }

        const paginationEl = this.carousel.querySelector('.swiper-pagination');
        const prevEl = this.carousel.querySelector('.swiper-button-prev');
        const nextEl = this.carousel.querySelector('.swiper-button-next');

        this.swiper = new window.Swiper(this.carousel, {
          slidesPerView: 1,
          slidesPerGroup: 1,
          spaceBetween: 10,
          loop: false,
          watchOverflow: true,
          navigation: {
            prevEl,
            nextEl,
          },
          pagination: {
            el: paginationEl,
            clickable: true,
          },
          breakpoints: {
            500: {
              slidesPerView: 2,
              slidesPerGroup: 1,
              spaceBetween: 10,
            },
          },
        });
      }

      initListingWhenReady() {
        if (this.listingInitialized) return;

        const gridReady = this.querySelector('.grid-wrapper');
        const wallpaperReady = typeof WallpaperItem === 'function';
        const samplesReady = typeof initSamples === 'function';

        if (!gridReady || !wallpaperReady || !samplesReady) {
          if (this.listingLoadAttempts < 40) {
            this.listingLoadAttempts += 1;
            this.listingTimeout = window.setTimeout(() => this.initListingWhenReady(), 50);
          }
          return;
        }

        this.initListing();
      }

      initListing() {
        if (this.listingInitialized) return;
        this.listingInitialized = true;

        try {
          this.querySelectorAll('.grid-filter-wrapper').forEach((el) => {
            if (typeof GridFilter === 'function') new GridFilter(el);
          });
        } catch (error) {
          console.error('GridFilter init failed:', error);
        }

        this.querySelectorAll('.item.is-wallpaper').forEach((el) => {
          if (typeof WallpaperItem === 'function') new WallpaperItem(el);
        });

        if (typeof initSamples === 'function') initSamples();

        this.initTabs();
      }

      initTabs() {
        const tabButtons = this.querySelectorAll('.tab-wrapper .tab-button');
        const tabs = this.querySelectorAll('.tab-container .tab');

        tabButtons.forEach((button, index) => {
          button.addEventListener('click', () => {
            if (button.classList.contains('active')) return;

            tabButtons.forEach((el) => el.classList.remove('active'));
            tabs.forEach((el) => el.classList.remove('active'));
            button.classList.add('active');
            tabs[index]?.classList.add('active');
          });
        });
      }
    }
  );
}
